import React from "react"

const Spacer = () => <div className="pa3 cf z-1 relative w-100">&nbsp;</div>

export default Spacer



// WEBPACK FOOTER //
// ./src/components/Spacer.js